'use client'

import type { ReactNode } from 'react'

import './Eligibility.css'

import { Fragment } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import parse from 'html-react-parser'

import { useIsMobile } from '@/hooks/useIsMobile'

interface EligibilityRow {
  title?: string
  title2?: string
  content?: string
  backgroundColor?: string
}
interface AgeBound {
  value?: string | number
  label?: string
}
export interface PropertyEligibilityProps {
  type?: string
  steps?: number
  title?: string
  subtext?: string
  highlightedText?: string
  documentsTitle?: string
  documentsTitle2?: string
  documents?: EligibilityRow[]
  eligibilityTitle?: string
  eligibility?: EligibilityRow[]
  horizontalTable?: boolean
  employeeType?: string
  tagline2?: string
  yearsOld?: string
  ageRange?: { minimum?: AgeBound; maximum?: AgeBound }
  income?: { range?: string; description?: string; subheading?: ReactNode }
  isReverse?: boolean
}

const PropertyEligibility = ({
  steps = 1,
  title = 'Apply easily',
  highlightedText = 'in just 1 step',
  documentsTitle = '',
  documentsTitle2,
  documents = [],
  eligibilityTitle = '',
  eligibility = [],
  horizontalTable = false,
  employeeType,
  yearsOld = 'years old',
  ageRange = {
    minimum: {
      value: '',
      label: 'Minimum Age'
    }
  },
  income = {
    range: 'RM 3,000 - RM 4,999',
    description: 'of minimum monthly gross income'
  },
  isReverse = false
}: PropertyEligibilityProps) => {
  const isTab = useIsMobile({ maxWidth: '992px' })

  return (
    <section id="prop-eligibility" className="values section h-100">
      <Container>
        <h2 data-aos="fade-up" className="requirements-text">
          <span>{title}</span>{' '}
          <span style={{ color: '#221AFB' }}>
            {highlightedText.split('\n').map((text, i) => (
              <Fragment key={i}>
                {parse(text)}
                {i === 0 && <br />}
              </Fragment>
            ))}
          </span>
        </h2>
        <Row
          className={`gy-4 align-items-end ${
            isReverse === true ? 'flex-column-reverse' : 'flex-column'
          } flex-xl-row`}
        >
          {documentsTitle && (
            <Col
              xl={steps === 2 ? 6 : 12}
              xs={12}
              className="d-flex justify-content-end flex-column required-documents"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              {/* {isReverse === false && (
                <p data-aos="fade-up" className="requirements-text">
                  <span>{title}</span>{" "}
                  <span style={{ color: "#221AFB" }}>
                    {highlightedText.split("\n").map((text, i) => (
                      <Fragment key={i}>
                        {text}
                        {i === 0 && <br />}
                      </Fragment>
                    ))}
                  </span>
                </p>
              )} */}

              <div
                className="d-flex flex-wrap order-xs-2 order-xl-1"
                data-aos="fade-right"
                data-aos-delay="200"
              >
                {documentsTitle2 ? (
                  <div className="docs-required-header two-title">
                    <p
                      style={{
                        width: '35%',
                        display: isTab ? 'none' : 'block'
                      }}
                    >
                      {documentsTitle}
                    </p>
                    <p
                      style={{
                        width: isTab ? '100%' : '65%',
                        textAlign: isTab ? 'center' : 'left'
                      }}
                    >
                      {documentsTitle2}
                    </p>
                  </div>
                ) : (
                  <div className="docs-required-header">{documentsTitle}</div>
                )}
                <div className="docs-required-content d-flex align-items-center flex-column bottom-border">
                  {documents?.map(doc => (
                    <div
                      key={doc.title}
                      className={`row border-row ${eligibilityTitle && 'widthy'}`}
                    >
                      {/* <div
                        key={index}
                        className={`col-md-6 ${
                          index === 0 ? "docs-subtext" : "docs-subtext-2"
                        }`}
                        style={{
                          backgroundColor: doc.backgroundColor,
                        }}
                      > */}
                      {doc?.title2 ? (
                        <div className="border-row-title">
                          {isTab ? parse(doc?.title2 ?? '') : parse(doc?.title ?? '')}
                        </div>
                      ) : (
                        <div className="border-row-title">{parse(doc?.title ?? '')}</div>
                      )}
                      {doc?.content && (
                        <div className="border-row-content">{parse(doc?.content)}</div>
                      )}
                      {/* </div> */}
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          )}
          {/* {eligibilityTitle && (
            <Col
              xl={steps === 2 ? 6 : 12}
              xs={12}
              className="d-flex justify-content-end flex-column"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              {steps === 1 && (
                <p data-aos="fade-up" className="requirements-text">
                  <span>{title}</span>{" "}
                  <span style={{ color: "#221AFB" }}>
                    {highlightedText.split("\n").map((text, i) => (
                      <Fragment key={i}>
                        {text}
                        {i === 0 && <br />}
                      </Fragment>
                    ))}
                  </span>
                </p>
              )}

              <div
                className="d-flex flex-wrap order-xs-2 order-xl-1"
                data-aos="fade-right"
                data-aos-delay="200"
              >
                <div className="docs-required-header">{eligibilityTitle}</div>
                <div
                  className={`docs-required-content d-flex align-items-center`}
                >
                  <div
                    className={`row w-100 ${
                      eligibility.length > 2 ? "flex-column" : "flex-row"
                    }`}
                  >
                    {eligibility?.map((doc, index) => (
                      <div
                        key={index}
                        className={`eligibility-subtext 
                        ${eligibility.length > 2 ? "col-12" : "col-md-6"}`}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#DCE9FF" : "#F2F4F7",
                        }}
                      >
                        {doc.title && (
                          <div
                            style={{
                              fontSize: "18px",
                              display: "flex",
                              justifyContent: "flex-start",
                              marginTop: "0",
                            }}
                          >
                            {parse(doc.title)}
                          </div>
                        )}
                        {doc.content && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              height: "80%",
                              marginLeft: "20px",
                            }}
                          >
                            {parse(doc.content)}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Col>
          )} */}

          {eligibilityTitle && (
            <Col
              xl={6}
              xs={12}
              className="order-xs-1 order-xl-2 eligibility-main-container"
              data-aos="fade-left"
              data-aos-delay="300"
            >
              <div className="docs-required-header text-start px-4 px-md-5">{eligibilityTitle}</div>
              {horizontalTable ? (
                <div className="docs-required-content d-flex align-items-center flex-column bottom-border">
                  {eligibility.map(doc => (
                    <div
                      key={doc.title}
                      className={`row border-row ${eligibilityTitle && 'widthy'}`}
                    >
                      {doc.title && <div className="border-row-title">{parse(doc.title)}</div>}
                      {doc.content && (
                        <div className="border-row-content">{parse(doc.content)}</div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <>
                  <div
                    className={`eligibilty-content ${
                      ageRange?.maximum?.value && 'justify-content-between'
                    }`}
                  >
                    {employeeType && (
                      <div className="eligibilty-subheader text-center">{employeeType}</div>
                    )}
                    <div className="eligibilty-age">
                      <div className="age_border">
                        <span className="purecounter">{ageRange?.minimum?.value}</span>
                        <span className="eligibility_age mx-2">{yearsOld}</span>
                      </div>
                      <div className="eligibility_age pt-2">{ageRange?.minimum?.label}</div>
                    </div>
                    {ageRange?.maximum?.value && (
                      <>
                        <div className="eligibilty-age middle">
                          <div className="table-desktop">
                            <span
                              style={{
                                borderBottomColor: '#231BFC',
                                borderBottomWidth: '6px',
                                borderBottomStyle: 'solid',
                                color: 'transparent'
                              }}
                            >
                              ,,,,,
                            </span>
                          </div>
                          <div className="table-mobile">
                            <span
                              style={{
                                borderBottomColor: '#231BFC',
                                borderBottomWidth: '6px',
                                borderBottomStyle: 'solid',
                                color: 'transparent'
                              }}
                            >
                              ,,,
                            </span>
                          </div>
                          <div></div>
                        </div>
                        <div className="eligibilty-age">
                          <div className="age_border">
                            <span className="purecounter">{ageRange.maximum.value}</span>
                            <span className="eligibility_age mx-2">{yearsOld}</span>
                          </div>
                          <div className="eligibility_age pt-2">{ageRange.maximum.label}</div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="eligibilty-content-2 p-5">
                    <div className="eligibilty-income">
                      {income?.subheading && (
                        <div className="eligibility_income">{income?.subheading}</div>
                      )}
                      <div>
                        <span style={{ fontSize: '48px' }}>{income?.range}</span>
                      </div>
                      {income?.description && (
                        <div className="eligibility_income">{income?.description}</div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </Col>
          )}
        </Row>
      </Container>
    </section>
  )
}

export default PropertyEligibility
